import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-nexus-chat',
  templateUrl: './nexus-chat.component.html',
  styleUrls: ['./nexus-chat.component.scss'],
})
export class NexusChatComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    this.chat();
  }

  chat() {
    (function (d, id) {
      var js = d.createElement('script');
      js.src = 'https://geia.cloudnexcore.com.br:3002/nchatsdk.js';
      // js.src = 'https://nexcore.geia.com.br:3002/nchatsdk.js';
      (d.head || d.getElementsByTagName('head')[0]).appendChild(js);
    })(document, 'chat-sdk');
  }
}
